import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button
} from '@mui/material';

const InactivateEmailDialog = ({ onConfirm, email ,mylist,handleClose}) => {
    console.log("mylist",mylist)
  return (
    <Dialog open={true} >
      <DialogTitle>Confirm { "  "}{mylist.status=="Inactive"?"Active":"Inactive"}</DialogTitle>
      <DialogContent>
        <DialogContentText>
        Are you sure you want to {mylist.status=="Inactive"?"Active":"Inactive"} this agent 
          <br />
          <strong>{mylist.email}{" "}?</strong>
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={(e)=>{handleClose(e)}} color="primary" variant="outlined">
          Cancel
        </Button>
        <Button onClick={(e)=>{onConfirm(e,mylist)}} color="error" variant="contained">
          OK
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default InactivateEmailDialog;
